import axios from "axios";
import router from "@/router";

const http = axios.create({
    baseURL: process.env.BASE_API_URL
});

http.interceptors.response.use(
    response => {
        return response;
    },
    error => {
        if(error.response.status === 401) {
            localStorage.clear("admin");
            router.push("/login");
        }

        console.log(error.response.status);
        return Promise.reject(error);
    }
);
  
export default http;


// WEBPACK FOOTER //
// ./src/http/index.js